export { createLogger } from './create-logger.js';
export type { Logger } from './create-logger.js';
